<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->

        <div class="app-main__outer">
            <div class="app-main__inner">
                <div class="app-page-title">
                    <div class="page-title-wrapper">
                        <div class="row headerRow Title">
                            <div class="col-sm-10">
                                <h3 class=""> Profile </h3>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row"> -->
                <form [formGroup]="proposalFrm">
                    <!-- <div class="card-body"> -->
                    <div class="row">
                        <div class="main-card card mb-3" style="width: 100%;">
                            <div class="row">
                                <div class="col-md-6">
                                    <table style="margin-left: 10px;margin-top: 10px; margin-bottom: 10px;">
                                        <tbody>
                                            <tr>
                                                <th style="text-align: left;"> Customer Name </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.name}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> Address </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.address}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> City
                                                </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.city}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> Pincode
                                                </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.pin}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> State
                                                </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.state}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="col-md-6">
                                    <table style="margin-right: 10px;margin-top: 10px;  margin-bottom: 10px;">
                                        <tbody>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;">Contact
                                                    Person
                                                    Name</th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.principle_contact_person }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> Phone Number
                                                </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.phone}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> Mobile Number
                                                </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.principle_contact_mobile}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> E-Mail
                                                </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.email}}</td>
                                            </tr>

                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> GSTIN
                                                </th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{customerData?.gstin_number}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->
                        <!--//////////Start Service Details //////////-->

                        <div class="col-md-12 multimodelContainer m-t-5">
                            <div class="main-card mb-3 card multimodel m-t-5">
                                <div class="row">
                                    <div class="col-md-3" style="margin-top: 12px;margin-left: 20px;">
                                        <h5 class='multiModelTitle'>Customer Authorized E-Mail</h5>
                                    </div>

                                    <div class="col-md-6" style="margin-top: 12px;">
                                        <button type="button" (click)="addCustomerEmailDetails()"
                                            class="btn-shadow d-inline-flex align-items-center btn btn-success">
                                            <i class="fa fa-plus fa-lg pointer m-t-5 blackColor" tooltip="Update"
                                                data-toggle="tooltip" data-placement="top" title=""
                                                data-original-title="View"></i>&nbsp;Add New
                                            <!-- (click)="onView(e.id)" -->
                                        </button>
                                    </div>

                                    <table class='multimodelTable'
                                        style='width:90%; margin-top: 15px; margin-left: 50px; margin-bottom: 15px;'>
                                        <thead>
                                            <th style="text-align: center;">
                                                E-Mail<span class="required-asterisk"> * </span>
                                            </th>
                                            <th style="text-align: center;">
                                                Name<span class="required-asterisk"> * </span>
                                            </th>
                                            <th style="text-align: center;">
                                                Designation<span class="required-asterisk"> * </span>
                                            </th>
                                            <th style="text-align: center;">
                                                Password
                                            </th>
                                            <th style="text-align: center;"></th>
                                        </thead>
                                        <tbody formArrayName="customerContactDetails" appearance="outline">
                                            <tr *ngFor="let customerContactDetails of getCustomerEmailDetails(); let j = index"
                                                [formGroupName]="j">
                                                <input hidden="true" formControlName="customerContactDetailsId"
                                                    class="ng-hide" />
                                                <td style="text-align: center;">
                                                    <div class="position-relative form-group">
                                                        <!-- <input placeholder="Enter Email" type="text" required
                                                            formControlName="email" class="form-control"> -->
                                                        <input placeholder="Enter E-Mail" type="text" required
                                                            formControlName="email" class="form-control">
                                                        <!-- [appUniqueEmail]="emailList" -->
                                                        <!-- (input)="checkDuplicateEmail($event,j)" -->
                                                    </div>
                                                    <div class="errorpopup alert alert-danger"
                                                        *ngIf="submitted && proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['email'].hasError('required')">
                                                        Email is Required
                                                    </div>
                                                    <div class="errorpopup alert alert-danger"
                                                        *ngIf="submitted && proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['email'].hasError('pattern')">
                                                        Please enter a valid email address
                                                    </div>
                                                    <div class="errorpopup alert alert-danger"
                                                        *ngIf="submitted && proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['email'].hasError('uniqueEmail')">
                                                        Duplicate Email
                                                    </div>
                                                </td>
                                                <td style="text-align: center;">
                                                    <div class="position-relative form-group">
                                                        <input placeholder="Enter Name" type="text" required
                                                            formControlName="name" class="form-control">
                                                    </div>
                                                    <div class="errorpopup alert alert-danger"
                                                        *ngIf="submitted && proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['name'].errors">
                                                        <div
                                                            *ngIf="proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['name'].errors.required">
                                                            Name is Required</div>
                                                    </div>
                                                </td>
                                                <td style="text-align: center;">
                                                    <div class="position-relative form-group">
                                                        <input placeholder="Enter Designation " type="text" required
                                                            formControlName="designation" class="form-control">
                                                    </div>
                                                    <div class="errorpopup alert alert-danger"
                                                        *ngIf="submitted && proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['designation'].errors">
                                                        <div
                                                            *ngIf="proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['designation'].errors.required">
                                                            Designation is Required</div>
                                                    </div>
                                                </td>
                                                <td style="text-align: center;">
                                                    <div class="position-relative form-group">
                                                        <input placeholder="Enter Password " type="text"
                                                            formControlName="password" class="form-control">
                                                    </div>
                                                    <div class="errorpopup alert alert-danger"
                                                        *ngIf="submitted && proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['password'].errors">
                                                        <div
                                                            *ngIf="proposalFrm.controls['customerContactDetails']['controls'][j]['controls']['password'].errors.required">
                                                            Password is Required</div>
                                                    </div>
                                                </td>
                                                <td style="width:5% !important;text-align: center;">
                                                    <!-- <button type="button"
                                                        class="btn btn-danger deletecros padding_left_ten"></button>
                                                    </button> -->
                                                    <i class="fa fa-trash fa-3 pointer" aria-hidden="true"
                                                        (click)="deleteCustomerEmailDetails(j)"></i>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-lg-12 pl-0" style="text-align: center;">
                                <button class="mt-2  mr-2 btn btn-primary" name="submit" type="submit"
                                    (click)="onSubmit()" [disabled]="submitted">Submit</button>
                            </div>

                        </div>

                        <!--////////// End Service Details //////////-->


                    </div>
                    <!-- </div> -->
                </form>
                <!-- </div> -->
            </div>
        </div>



    </div>
</div>